/* eslint-disable */
/// This file is auto generated - do not edit manually
export const ClickAndCollectStorePrefix = 'Website.Basket.ClickAndCollect.ClickAndCollectStorePrefix';
